<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import imageMixin from 'src/mixins/imageMixin'
import staffApi from 'src/apis/masters/staff'

const api = staffApi
const displayPageName = '担当者'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      search: {
        tantouId: null,
      },
      origList: [],
      list: [],
      roleCands: [],
      saveCandidate: {},
      showSaveModal: false,
      showImprintModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
    isImprintUploaded() {
      const imprint = this.saveCandidate.imprint
      return !!imprint && imprint.isNew
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    this.prepareMasters()
    this.prepareSearchParams()
    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin, imageMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.roleCands = master.role.vals
    },
    prepareSearchParams() {
      const search = {
        tantouId: null,
      }
      if (this.roleCands.length > 0) {
        search.tantouId = this.roleCands[0].m_role_id
      }
      this.search = search
    },
    filterListBySearchParams() {
      this.pagination.currentPage = 1
      this.list = this.origList.filter(e => e.tantou_id === this.search.tantouId)
    },
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await staffApi.index()
        this.origList = data
        this.filterListBySearchParams()
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
        saveCandidate.tantou_id = this.search.tantouId
        saveCandidate.yuukou_flg = 0
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.saveCandidate,
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
    openImprintModal(item) {
      const saveCandidate = JSON.parse(JSON.stringify(item))
      if (saveCandidate.imprint) {
        saveCandidate.imprint.src =
          saveCandidate.imprint.signed_id // alias
      }
      this.saveCandidate = saveCandidate
      this.showImprintModal = true
    },
    closeImprintModal() {
      this.saveCandidate = {}
      this.showImprintModal = false
    },
    async saveImprint() {
      if (!this.isImprintUploaded) { return }

      try {
        const formData = new FormData()
        formData.append('imprint', this.saveCandidate.imprint.file)
        await staffApi.updateImprint(this.saveCandidate.id, formData)
        await this.getList()
        this.closeImprintModal()
        this.notifySuccess1('印影を登録しました。')
      } catch (err) {
        const msg = '印影の登録に失敗しました。管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files || files.length === 0) { return }

      const f = files[0]
      // 上限サイズは3MB
      if (f.size > 3000000) {
        const msg = 'ファイルの上限サイズ3MBを超えています。'
        event.currentTarget.value = ''
        this.notifyError1(msg)
        return
      }
      // 拡張子は .png のみ許可
      if (f.type !== 'image/png') {
        const msg = '.pngファイルのみ許可されています。'
        event.currentTarget.value = ''
        this.notifyError1(msg)
        return
      }

      const imprint = {
        filename: f.name,
        type: f.type,
        file: f,
        src: window.URL.createObjectURL(f),
      }
      imprint.isNew = true
      this.saveCandidate.imprint = imprint
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
